import axios from 'axios'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getErrorMessageByStatusCode } from '../../util/utilityFunction'
import useLoadingStore from '../../stores/useLoadingStore'
import ConfigAPI from '../../constant/ConfigAPI'

const useContact = () => {
    const [data, setData] = useState<ContactUsType>()
    const [noDataMessage, setNoDataMessage] = useState<string>('')
    const [isDataNotFound, setIsDataNotFound] = useState<boolean>(false)
    const loadingStore = useLoadingStore()
    const { t } = useTranslation()

    useEffect(() => {
        callService()
    }, [])

    const callService = async () => {
        try {
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/content/contactus`
            const result = await axios.get(url, ConfigAPI)

            if (result.data) {
                setNoDataMessage('')
                setIsDataNotFound(false)
                setData(result.data)

                if (!result.data) {
                    setNoDataMessage('อยู่ระหว่างการปรับปรุงเนื้อหา')
                }
            }

            return { result }
        } catch (error) {
            if (error) {
                //@ts-ignore
                const errMsg: string = error?.toString()
                if (errMsg) {
                    if (errMsg.includes('404')) {
                        setNoDataMessage('ไม่มีแผนการดำเนินการ')
                    } else {
                        setNoDataMessage(getErrorMessageByStatusCode(errMsg, t('MENU.CONTACT')))
                    }
                    setIsDataNotFound(true)
                }
            }
            return { error }
        } finally {
            loadingStore.setLoading(false)
        }
    }

    return {
        data,
        noDataMessage,
        isDataNotFound,
    }
}

export default useContact
